import "./SitesList.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SitesListComponentController from "./SitesListComponentController";

export class SitesListComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            extraClasses: "@",
            readOnly: "<",
        };
        this.controller = SitesListComponentController;
        this.templateUrl = "/App/Components/SitesList/SitesList.html";
    }
}

module("mmManagePortal").component("mmSitesList", new SitesListComponent());
